<template>
    <div class="pta-admin">
        <div class="page-titles border-bottom">
            <h3>AI Recommender</h3>
        </div>
      <div class="container-fluid p-0" style="font-size: 0.75em;">
        <div class="card" v-if="users.total">
          <div class="card-body">
            <div class="table-responsive" v-if="hasPermission('list-user') && users.total">
              <table class="table table-hover">
                <thead>
                <tr>
                  <th scope="col">{{trans('user.first_name')}}</th>
                  <th scope="col">{{trans('user.last_name')}}</th>
                  <th scope="col">{{trans('user.email')}}</th>
                  <th scope="col">Premium</th>
                  <th scope="col">{{trans('user.status')}}</th>
                  <th scope="col" class="table-option">{{trans('general.action')}}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="user in users.data" v-if="user.investors.length">
                  <td v-text="user.profile.first_name"></td>
                  <td v-text="user.profile.last_name"></td>
                  <td v-text="user.email"></td>
                  <td v-text="user.profile.is_premium?'Yes':'No'"></td>
                  <td><span v-for="status in getUserStatus(user)" :class="['label','label-'+status.color,'m-r-5']">{{status.label}}</span></td>
                  <td class="table-option">
                    <div class="btn-group">
                      <router-link v-if="user.investors.length" :to="`/account/users/general-partners/${user.id}/investors`" class="btn btn-inverse btn-sm" v-tooltip="'Investor List'"><i class="fas fa-user-group"></i></router-link>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <!--  <module-info v-if="!users.total" module="user" title="module_info_title" description="module_info_description" icon="users">
                  <div slot="btn">
                      <button class="btn btn-info btn-sm" v-if="hasPermission('create-user') && !showCreatePanel" @click="showCreatePanel = !showCreatePanel"><i class="fas fa-plus"></i> {{trans('general.add_new')}}</button>
                  </div>
              </module-info>
               --><pagination-record :page-length.sync="filterUserForm.page_length" :records="users" @updateRecords="getUsers"></pagination-record>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
export default {
  components : {  },
  data() {
    return {
      users: {
        total: 0,
        data: []
      },
      filterUserForm: {
        name: '',
        email: '',
        role_id: '',
        status: '',
        created_at_start_date: '',
        created_at_end_date: '',
        sort_by : 'first_name',
        order: 'asc',
        page_length: 50
      },
    };
  },
  mounted(){
    if(!helper.hasPermission('list-user') && !helper.hasPermission('create-user')){
      helper.notAccessibleMsg();
      this.$router.push('/home');
    }
    this.getUsers();
  },
  methods: {
    hasPermission(permission){
      return helper.hasPermission(permission);
    },
    getUserStatus(user){
      return helper.getUserStatus(user);
    },
    getUsers(page){
      if (typeof page !== 'number') {
        page = 1;
      }
      let url = helper.getFilterURL(this.filterUserForm);
      axios.get('/api/user?page=' + page + url)
          .then(response => response.data)
          .then(response => this.users = response)
          .catch(error => {
            helper.showDataErrorMsg(error);
          })
    },
  },
  filters: {

  }
}
</script>
<style>
.pta-ai-results table td{
  font-size:0.8em;
  line-height:1.25em;
  padding:8px;
  vertical-align:top;
}
.pta-ai-results table tr:nth-child(odd){
  background:#efefef;
}
</style>